import CollaboMenu from './CollaboMenu';

export default CollaboMenu;
